import { render, staticRenderFns } from "./TemporarySave.vue?vue&type=template&id=6986d532&"
import script from "./TemporarySave.vue?vue&type=script&lang=ts&"
export * from "./TemporarySave.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports